import { render } from "./main-component.vue?vue&type=template&id=e45350ba"
import script from "./main-component.vue?vue&type=script&lang=js"
export * from "./main-component.vue?vue&type=script&lang=js"

import "./main-component.vue?vue&type=style&index=0&id=e45350ba&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.3.1_vue@3.5.13_webpack@5.102.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"assets/js/mainapp/components/main-component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e45350ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e45350ba', __exports__)) {
    api.reload('e45350ba', __exports__)
  }
  
  module.hot.accept("./main-component.vue?vue&type=template&id=e45350ba", () => {
    api.rerender('e45350ba', render)
  })

}


export default __exports__